/**
 * @generated SignedSource<<2dad237a1169707979f1c2965a4d4146>>
 * @relayHash d3f124aab91672208e07302d03b07351
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c184940bfc597924791e760a99e4cec505eb44de79daa104a6aa46e6adac4b2b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type KnowledgeDiscoveryKeyPhraseCategory = "ACRONYM" | "AUTO" | "OTHER" | "PROJECT" | "TEAM" | "%future added value";
export type HighlightKeywordsQuery$variables = {
  pageARI?: string | null | undefined;
  workspaceId?: string | null | undefined;
};
export type HighlightKeywordsQuery$data = {
  readonly knowledgeDiscovery: {
    readonly keyPhrases: {
      readonly __typename: "KnowledgeDiscoveryKeyPhraseConnection";
      readonly nodes: ReadonlyArray<{
        readonly category: KnowledgeDiscoveryKeyPhraseCategory;
        readonly keyPhrase: string;
      } | null | undefined> | null | undefined;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type HighlightKeywordsQuery = {
  response: HighlightKeywordsQuery$data;
  variables: HighlightKeywordsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageARI"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "concreteType": "KnowledgeDiscoveryQueryApi",
    "kind": "LinkedField",
    "name": "knowledgeDiscovery",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "pageARI"
          },
          {
            "kind": "Variable",
            "name": "workspaceId",
            "variableName": "workspaceId"
          }
        ],
        "kind": "LinkedField",
        "name": "keyPhrases",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "KnowledgeDiscoveryKeyPhrase",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "keyPhrase"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "category"
                  }
                ]
              }
            ],
            "type": "KnowledgeDiscoveryKeyPhraseConnection"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HighlightKeywordsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HighlightKeywordsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d3f124aab91672208e07302d03b07351",
    "id": "c184940bfc597924791e760a99e4cec505eb44de79daa104a6aa46e6adac4b2b",
    "metadata": {},
    "name": "HighlightKeywordsQuery",
    "operationKind": "query",
    "text": "query HighlightKeywordsQuery($pageARI:String,$workspaceId:String){knowledgeDiscovery{keyPhrases(entityAri:$pageARI,workspaceId:$workspaceId)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}"
  }
};
})();

(node as any).hash = "2eaa54e2c6daee5ed7b85802235eee06";

export default node;
